import AutoplayLimitPopup from '../../../../vendor_core/core/src/ui/popups/AutoplayLimitPopup';
import ViewManager from '../../../../vendor_core/core/src/utils/ViewManager';

export default class BBAutoplayLimitPopup extends AutoplayLimitPopup {
    public show(callback?: Function) {
        super.show();
        // show popup background
        ViewManager.getLayer("PopupsBackground").setScene("open");
    }

    public hide = () => {
        super.hide();
        // clear popup background
        ViewManager.getLayer("PopupsBackground").clear();
    }
}
